// generated by genversion
export var version = '4.2.3';
//# sourceMappingURL=version.js.map